[
  {
    "code": "IR-03",
    "name": "Ardabil"
  },
  {
    "code": "IR-02",
    "name": "Az¯arbayjan-e Gharbi"
  },
  {
    "code": "IR-01",
    "name": "Az¯arbayjan-e Sharqi"
  },
  {
    "code": "IR-06",
    "name": "Bushehr"
  },
  {
    "code": "IR-08",
    "name": "Chahar Mah¸all va Bakhtiari"
  },
  {
    "code": "IR-04",
    "name": "Esfahan"
  },
  {
    "code": "IR-14",
    "name": "Fars"
  },
  {
    "code": "IR-19",
    "name": "Gilan"
  },
  {
    "code": "IR-27",
    "name": "Golestan"
  },
  {
    "code": "IR-24",
    "name": "Hamadan"
  },
  {
    "code": "IR-23",
    "name": "Hormozgan"
  },
  {
    "code": "IR-05",
    "name": "Ilam"
  },
  {
    "code": "IR-15",
    "name": "Kerman"
  },
  {
    "code": "IR-17",
    "name": "Kermanshah"
  },
  {
    "code": "IR-29",
    "name": "Khorasan-e Janubi"
  },
  {
    "code": "IR-30",
    "name": "Khorasan-e Razavi"
  },
  {
    "code": "IR-31",
    "name": "Khorasan-e Shemali"
  },
  {
    "code": "IR-10",
    "name": "Khuzestan"
  },
  {
    "code": "IR-18",
    "name": "Kohkiluyeh va Buyer Ahmad"
  },
  {
    "code": "IR-16",
    "name": "Kordestan"
  },
  {
    "code": "IR-20",
    "name": "Lorestan"
  },
  {
    "code": "IR-22",
    "name": "Markazi"
  },
  {
    "code": "IR-21",
    "name": "Mazandaran"
  },
  {
    "code": "IR-28",
    "name": "Qazvin"
  },
  {
    "code": "IR-26",
    "name": "Qom"
  },
  {
    "code": "IR-12",
    "name": "Semnan"
  },
  {
    "code": "IR-13",
    "name": "Sistan va Baluchestan"
  },
  {
    "code": "IR-07",
    "name": "Tehran"
  },
  {
    "code": "IR-25",
    "name": "Yazd"
  },
  {
    "code": "IR-11",
    "name": "Zanjan"
  }
]